<template>
	<div>
		<b-modal ref="setProjectNameModal"
			@ok="setProjectName(name)"
			@cancel="name = oldName"
			title="Edition"
			id="name"
			:cancel-title="'Annuler'">
			<label for="name">{{ $t("Navbar.video_name") }}</label> <br>
			<b-form-input ref="focusThis"
				type="text"
				id="name"
				v-model="name"></b-form-input>
			<br>
		</b-modal>
		<b-navbar toggleable="md"
			type="dark">
			<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
			<b-navbar-brand :to="{ name: 'Dashboard'}">
					<img :src="logoPath">
			</b-navbar-brand>
			<b-collapse is-nav
				id="nav_collapse">
				<b-navbar-nav class="mx-auto text-center">
					<b-nav-text style="color: var(--text-navbar);">{{ this.name }} <img v-if="this.editable"
						@click="openModal"
						:src="'./static/images/navnameedit.png'"
						height="20"
						class="text-edit"></b-nav-text>
				</b-navbar-nav>

<!--				<b-button v-if="this.editable && !helpState"-->
<!--					class="help-button"-->
<!--					@click.prevent="setHelp">-->
<!--					{{ $t("Button.enable_tooltip") }}-->
<!--				</b-button>-->
<!--				<b-button v-if="this.editable && helpState"-->
<!--					class="help-button"-->
<!--					@click.prevent="setHelp">-->
<!--					{{ $t("Button.disable_tooltip") }}-->
<!--				</b-button>-->

				<router-link :to="{ name: 'Help'}">
					<img :src="'./static/images/help.png'" height="20" id="help_link">
				</router-link>

				<b-navbar-nav v-if="false">
					<b-nav-item @click="changeLocale('fr')">FR</b-nav-item>
					<b-nav-item @click="changeLocale('en')">EN</b-nav-item>
				</b-navbar-nav>

				<b-navbar-nav>
					<b-nav-item-dropdown right id="main_dropdown">
						<template slot="button-content">
							<em class="username">{{ username }}</em>
						</template>

						<!--						<b-dropdown-item @click="logout">-->
						<!--							<img :src="'./static/images/account.png'" alt="" class="dropdown-icon" />Mon compte-->
						<!--						</b-dropdown-item>-->

						<!--						<b-dropdown-item @click="logout">-->
						<!--							<img :src="'./static/images/confidentiality.png'" alt="" class="dropdown-icon" />Confidentialité-->
						<!--						</b-dropdown-item>-->

						<!--						<b-dropdown-item @click="logout">-->
						<!--							<img :src="'./static/images/contact.png'" alt="" class="dropdown-icon" />Contact-->
						<!--						</b-dropdown-item>-->

						<b-dropdown-item @click="logout">
							<img :src="'./static/images/logout.png'" alt="" class="dropdown-icon" />{{ $t("Menu.logoff") }}
						</b-dropdown-item>

					</b-nav-item-dropdown>
				</b-navbar-nav>
			</b-collapse>
		</b-navbar>
	</div>
</template>

<script>
import {EventBus} from "../../event/event-bus";

export default {
	name: "Navbar",
	props: {
		name: {
			type: String,
			required: true,
		},
		setProjectName: {
			type: Function,
			required: false,
		},
		oldName: {
			type: String,
			required: false,
		},
		setHelp: {
			type: Function,
			required: false,
		},
		helpButtonText: {
			type: String,
			required: false,
			default: "",
		},
		helpState: {
			type: Boolean,
			required: false,
			default: false,
		},
		editable: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data() {
		return {
			logoPath: process.env.VUE_APP_NAVBAR_LOGO_PATH,
			username: sessionStorage.getItem("username"),
			projectName: this.name,
		};
	},
	created() {
		let $this = this;
		EventBus.$on("setHelpText", function (text) {
			$this.helpButtonText = text;
		});
	},
	methods: {
		setNavbarText() {
			if (this.$route.name === "Dashboard") {
				return this.$root.$t("Dashboard.name");
			}
			else if (this.$route.name === "ThematicSelection") {
				return "Création d'une nouvelle vidéo";
			}
			else if (this.$route.name === "ProjectEdition") {
				return sessionStorage.getItem("projectName");
			}
			else {
				return "Nouveau projet";
			}
		},
		logout() {
			this.$router.push({name: "Home"});
		},
		openModal() {
			this.$refs.setProjectNameModal.show();
			if (this.$refs.setProjectNameModal.false) {
				this.projectName = this.$route.query.n;
			}
			this.$refs.focusThis.focus();
		},
		changeLocale(locale) {
			this.$root.$i18n.locale = locale;
			localStorage.setItem("lang", locale);
			EventBus.$emit("setLanguage", locale);
		},
	},
};
</script>

<style scoped>

.navbar {
	margin: 0 var(--big-border-radius);
	border-radius: 0 0 var(--big-border-radius) var(--big-border-radius);
	height: 60px;
	background: var(--background-navbar);
}

.dropdown-icon {
	width: 22px;
	height: 22px;
	float: right;
}

.text-edit {
	cursor: pointer;
	color: var(--text-main);
	margin-bottom: .5rem;
	margin-left: 1rem;
}

.username {
	color: var(--text-navbar);
	margin-right: 10px;
}

.help-button,
.help-button:hover,
.help-button:active {
	margin-right: 1.5rem;
	color: var(--text-help);
	background: var(--background-help);
}

#help_link {
	margin-right: 15px;
	height: 20px;
}

</style>
